declare let SERVER: { DEBUG: boolean; };
/*
Note: there are media files that we have to proxy:
- article media: can come from a generic url, we can't trust that the CORS
    headers will be set correctly to add the asset into a canvas
- tenor: currently there are no Access-Control-Allow-Origin headers for tenor.
    Nigel is working with one of the Tenor engineers to try to get them to add
    the header. For now, we will proxy them.
*/
export const ASSET_URL_WHITELIST = [
    'storage.googleapis.com/lumen5-prod-images',
    'storage.googleapis.com/lumen5-prod-video',
    'storage.googleapis.com/lumen5-dev-images',
    'storage.googleapis.com/lumen5-dev-video',
    'storage.googleapis.com/lumen5-mock-images',
    'storage.googleapis.com/lumen5-mock-video',
    'storage.googleapis.com/lumen5-user-',
    'media.gettyimages.com/photos',
    'media.gettyimages.com/videos',
    'media.gettyimages.com/vectors',
    'upload.wikimedia.org/wikipedia/commons',
    'http://logo.clearbit.com',
    'picdn.net/shutterstock',
    'cloudinary.com',
    'https://clips-presenters.d-id.com',
];


/*
We need to compute which media proxy we should use. There are the following cases:
1. video data server
    - dev: media-share.lumen5.com
    - production: media-share.lumen5.com
    - mock environment: media-share-<mock-env>.lumen5.com
2. in browser
    - dev:
        - in the `web` repo: localhost:7999
        - in the editor (or template-editor, etc): media-share.lumen5.com
    - prod: media-share.lumen5.com
    - mock environment: media-share-<mock-env>.lumen5.com
    - tests:
        - karma (window.location.host is "localhost"): media-share.lumen5.com
        - end-to-end (window.location.host is "backend"): media-share.lumen5.com
*/

const getMediaProxyBaseUrl = () => {
    const PRODUCTION_HOST = 'lumen5.com';
    const convertHostToMediaProxyBaseUrl = (host: string) => {
        // sub-domains use media-share-subdomain.lumen5.com
        // while the top-level domain uses media-share.lumen5.com
        let joiner = '.';
        if (host.split('.').length >= 3) {
            joiner = '-';
        }
        return `https://media-share${joiner}${host}/proxy-url/?url=`;
    };

    if (typeof process !== 'undefined') {
        // we are in the video-data-server
        return convertHostToMediaProxyBaseUrl(PRODUCTION_HOST);
    }
    else {
        // we are in the browser
        const host = window.location.host;
        if (typeof SERVER !== 'undefined' && SERVER.DEBUG === true) {
            // we are in the web repo in dev
            return 'http://localhost:7999/proxy-url/?url=';
        }
        else if (host.indexOf('localhost') >= 0) {
            // we are in a different dev environment, like the editor or something
            // or we are in the karma tests
            return convertHostToMediaProxyBaseUrl(PRODUCTION_HOST);
        }
        else if (host.indexOf('backend:8000') >= 0) {
            // we are in the end-to-end tests
            return convertHostToMediaProxyBaseUrl(PRODUCTION_HOST);
        }
        else {
            // we are in a mock environment or in production
            return convertHostToMediaProxyBaseUrl(host);
        }
    }
};


export const MEDIA_PROXY_BASEURL = getMediaProxyBaseUrl();

export enum FONT_STATUS {
    ADDED = 0,
    LOADING = 1,
    LOADED = 2,
    FAILED = 3
}

export const VIDEO_DATA_SERVER_BUGSNAG_API_KEY = '1ead04b9b1cad0b5277324648968ea99';

export const LOTTIE_ORIGINAL_DURATION = 'LOTTIE_ORIGINAL_DURATION';

